import type { SearchParams } from '@/server/searchParams.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import { ClickEventNameEnum } from '@/app/components/search/Curiosity/Analytics/utils/ClickEventNameEnum.ts';
import type { Localization } from '@/app/components/search/common/Localization';

export const RESULT_PAGE_MAP_ACTION = 'RESULT_PAGE_MAP_ACTION';
export const RESULT_PAGE_MAP_ACTION_VERSION = '1.0';

const RESULT_PAGE_MAP_ACTION_TYPE = {
  [ClickEventNameEnum.MapPanning as string]: 'DRAG',
  [ClickEventNameEnum.MapZoomIn as string]: 'ZOOM-IN',
  [ClickEventNameEnum.MapZoomOut as string]: 'ZOOM-OUT',
};

export type ResultPageMapActionParams = {
  searchParams: SearchParams;
  clickEventName: ClickEventNameEnum;
  localization: Localization;
};

export type ResultPageMapActionPayload = {
  searchId: string;
  action: string;
};

export const createResultPageMapActionPayload = (params: ResultPageMapActionParams): ResultPageMapActionPayload => {
  const { searchParams, clickEventName } = params;
  const searchId = searchParams[URLParameters.SEARCH_ID];
  const action = RESULT_PAGE_MAP_ACTION_TYPE[clickEventName];
  if (!searchId) throw new Error('searchId not present in searchParams');

  const payload = {
    searchId,
    action,
  };

  return payload;
};
